import * as React from "react";
import tiktok_logo from "../../../images/tiktok_logo3.png";


export class TikTokConnectButton extends React.Component {

    render() {
        return <button className="btn tiktok" onClick={this.props.onClick}>{this.renderTikTokLogo()}Conectar a Tiktok Ads</button>
    }

    getImage() {
        return tiktok_logo;
    }

    renderTikTokLogo() {
        return <img alt="Tiktok Ads" src={this.getImage()} height={30} width={30} hspace={10} vspace={10}/>
    }
}
